<app-mat-spinner-overlay *ngIf="loading" overlay="true"></app-mat-spinner-overlay>
<div class="loginContainer fadey" *ngIf="!createToggle">
		<div class="card m-auto align-middle">
			<div class="card-header">
				<h3>Sign In</h3>
			</div>
			<div class="card-body">
				<form [formGroup]="form" class="pt-3">
					<div class="input-group form-group">
						<div class="input-group-prepend">
              <fa-icon [icon]="faUser" class="fa my-auto mx-auto" style="font-size: 1.25em"></fa-icon>
						</div>
						<input appAutoFocus type="text" class="form-control" formControlName="userid" placeholder="Userid">
					</div>
					<div class="input-group form-group">
						<div class="input-group-prepend">
              <fa-icon [icon]="faKey" class="fa my-auto mx-auto" style="font-size: 1.25em"></fa-icon>
            </div>
						<input type="password" class="form-control" formControlName="password" placeholder="Password">
          </div>
          <div class="d-flex justify-content-between flex-column button-container">
            <div class="form-group">
						<input type="submit" value="Sign In" class="btn float-right login_btn text-white" (click)="login()" [disabled]="loading">
          </div>
          <div class="form-group">
						<input type="submit" value="Create Account" class="btn float-right login_btn text-white" (click)="toggleCreate()">
					</div>
        </div>
				</form>
			</div>
		</div>
	</div>

<div class="loginContainer fadey" *ngIf="createToggle">
  <div class="card m-auto align-middle">
    <div class="card-header">
      <h3>Create Account</h3>
    </div>
    <div class="card-body">
      <form [formGroup]="form" class="pt-3">
        <div class="input-group form-group">
          <div class="input-group-prepend">
            <fa-icon [icon]="faUser" class="fa my-auto mx-auto" style="font-size: 1.25em"></fa-icon>
          </div>
          <input appAutoFocus type="text" class="form-control" formControlName="userid" placeholder="Userid">
        </div>
        <div class="input-group form-group">
          <div class="input-group-prepend">
            <fa-icon [icon]="faKey" class="fa my-auto mx-auto" style="font-size: 1.25em"></fa-icon>
          </div>
          <input type="password" class="form-control" formControlName="password" placeholder="Password">
        </div>
        <div class="d-flex justify-content-between flex-column button-container">
          <div class="form-group">
            <input type="submit" value="Create Account" class="btn float-right login_btn text-white" (click)="createAccount()" [disabled]="loading">
          </div>
          <div class="form-group">
            <input type="submit" value="Back" class="btn float-right login_btn text-white" (click)="toggleCreate()">
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
